import type { PaletteMode, Shadows } from '@mui/material/styles';

const lightShadows = [
  'none',
  '0px 2px 8px rgba(15, 23, 42, 0.05)',
  '0px 4px 16px rgba(15, 23, 42, 0.08)',
  '0px 8px 24px rgba(15, 23, 42, 0.08)',
  '0px 12px 30px rgba(15, 23, 42, 0.1)',
  '0px 16px 36px rgba(15, 23, 42, 0.12)',
  '0px 20px 44px rgba(15, 23, 42, 0.14)',
  '0px 24px 48px rgba(15, 23, 42, 0.14)',
  '0px 28px 56px rgba(15, 23, 42, 0.15)',
  '0px 32px 64px rgba(15, 23, 42, 0.16)',
  '0px 36px 72px rgba(15, 23, 42, 0.17)',
  '0px 40px 76px rgba(15, 23, 42, 0.17)',
  '0px 44px 80px rgba(15, 23, 42, 0.18)',
  '0px 48px 84px rgba(15, 23, 42, 0.18)',
  '0px 52px 88px rgba(15, 23, 42, 0.19)',
  '0px 56px 92px rgba(15, 23, 42, 0.2)',
  '0px 60px 96px rgba(15, 23, 42, 0.2)',
  '0px 64px 100px rgba(15, 23, 42, 0.21)',
  '0px 68px 104px rgba(15, 23, 42, 0.21)',
  '0px 72px 108px rgba(15, 23, 42, 0.22)',
  '0px 76px 112px rgba(15, 23, 42, 0.22)',
  '0px 80px 116px rgba(15, 23, 42, 0.23)',
  '0px 84px 120px rgba(15, 23, 42, 0.23)',
  '0px 88px 124px rgba(15, 23, 42, 0.24)',
  '0px 92px 128px rgba(15, 23, 42, 0.24)',
] as Shadows;

const darkShadows = [
  'none',
  '0px 2px 8px rgba(2, 6, 23, 0.32)',
  '0px 4px 16px rgba(2, 6, 23, 0.36)',
  '0px 8px 24px rgba(2, 6, 23, 0.4)',
  '0px 12px 30px rgba(2, 6, 23, 0.42)',
  '0px 16px 36px rgba(2, 6, 23, 0.44)',
  '0px 20px 44px rgba(2, 6, 23, 0.46)',
  '0px 24px 48px rgba(2, 6, 23, 0.48)',
  '0px 28px 56px rgba(2, 6, 23, 0.5)',
  '0px 32px 64px rgba(2, 6, 23, 0.52)',
  '0px 36px 72px rgba(2, 6, 23, 0.54)',
  '0px 40px 76px rgba(2, 6, 23, 0.55)',
  '0px 44px 80px rgba(2, 6, 23, 0.56)',
  '0px 48px 84px rgba(2, 6, 23, 0.57)',
  '0px 52px 88px rgba(2, 6, 23, 0.58)',
  '0px 56px 92px rgba(2, 6, 23, 0.59)',
  '0px 60px 96px rgba(2, 6, 23, 0.6)',
  '0px 64px 100px rgba(2, 6, 23, 0.61)',
  '0px 68px 104px rgba(2, 6, 23, 0.62)',
  '0px 72px 108px rgba(2, 6, 23, 0.63)',
  '0px 76px 112px rgba(2, 6, 23, 0.64)',
  '0px 80px 116px rgba(2, 6, 23, 0.65)',
  '0px 84px 120px rgba(2, 6, 23, 0.66)',
  '0px 88px 124px rgba(2, 6, 23, 0.67)',
  '0px 92px 128px rgba(2, 6, 23, 0.68)',
] as Shadows;

export function getShadows(mode: PaletteMode): Shadows {
  return mode === 'dark' ? darkShadows : lightShadows;
}